/* CreditsPackages.js */
/* @author: anghello */

module.exports.CreditsPackages = Object.freeze({
  package1: {
    title: '1K Credits',
    price: 12,
    credits: 1000,
    stripe_price_id_test: process.env.REACT_APP_STRIPE_PRICE_ID_PACK_1K,
    stripe_price_id_production: process.env.REACT_APP_STRIPE_PRICE_ID_PACK_1K
  },
  package2: {
    title: '5K Credits',
    price: 58,
    credits: 5000,
    stripe_price_id_test: process.env.REACT_APP_STRIPE_PRICE_ID_PACK_5K,
    stripe_price_id_production: process.env.REACT_APP_STRIPE_PRICE_ID_PACK_5K
  },
  package3: {
    title: '10K Credits',
    price: 110,
    credits: 10000,
    stripe_price_id_test: process.env.REACT_APP_STRIPE_PRICE_ID_PACK_10K,
    stripe_price_id_production: process.env.REACT_APP_STRIPE_PRICE_ID_PACK_10K
  },
});